import React, { FC } from "react";
import { OrganizationInfo } from '../../../models/api-models/organization/organization-info';

interface TermAndConditionProps {
    organization: OrganizationInfo;
}

export const TermsAndConditions: FC<TermAndConditionProps> = ({ organization }) => {
    const privacyPolicy = organization.organizationPolicy.privacyPolicyUrl && organization.organizationPolicy.privacyPolicyUrl.length
        ? (<a href={organization.organizationPolicy.privacyPolicyUrl} target='_blank'>privacy policy</a>) : ("privacy policy");

    if (organization.organizationPolicy.smsTermsAndConditionsUrl !== window.location.href) {
        return (<div className="policy-header">Not Found</div>);
    }
    return (<React.Fragment>
             <div className="policy-header">{organization.title}'s SMS Terms and Conditions</div>
                <div className="policy-body">
                    <div className="body-content">
                          <p className="body-info">1. Coaches use texting to communicate with you as part of the recruiting process.
                             They request additional information about you or invite you to recruiting events and camps.
                          </p>
                          <p className="body-info">2. You can cancel the SMS service at any time. Just text "STOP" to the short code.
                                After you send the SMS message "STOP" to us, we will send you an SMS message to confirm that you have been unsubscribed.
                                After this, you will no longer receive SMS messages from us.
                                If you want to join again, just sign up as you did the first time and we will start sending SMS messages to you again.
                          </p>
                          <p className="body-info">3. If you are experiencing issues with the messaging program you can reply with the keyword HELP for more assistance.
                          </p>
                          <p className="body-info">4. Carriers are not liable for delayed or undelivered messages.</p>
                          <p className="body-info">5. As always, message and data rates may apply for any messages sent to you from us and to us from you.
                                            You will receive 1-2 messages weekly.
                                            If you have any questions about your text plan or data plan, it is best to contact your wireless provider.
                          </p>
                          <p className="body-info">6. If you have any questions regarding privacy, please read our {privacyPolicy}.</p>
                    </div>
                </div>
           </React.Fragment>)
}